const FaqSubtitle = ({ subtitle }) => {
  return (
    <div className="font-text font-body pt-10 text-black text-3xl">
      {subtitle}
    </div>
  );
};

export default FaqSubtitle;
